const API_CONFIG = {
    urlListarEmpreendimentos: "/api/produtos/empreendimentos",
    urlListarUnidades: "/api/produtos/unidades",
    urlSimularProposta: "/api/propostas/simular",
    urlRatingPrepac: "/api/rating/prepac",
    urlInicializarPropostaFlex: "/api/propostas/inicializar",
    urlSimularPropostaFlex: "/api/propostas/flex/simular",
};

export default API_CONFIG;